document.addEventListener('DOMContentLoaded', () => {
  const initCounters = () => {
    const statItems = document.querySelectorAll('.qube-statistic-number-value');
    
    if (statItems.length === 0) return;

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const target = entry.target;
          const targetNumber = parseInt(target.getAttribute('data-target'), 10);
          
          if (!isNaN(targetNumber)) {
            animateNumber(target, targetNumber, 2000); // 2 seconds animation
          }
          
          observer.unobserve(target); // Only animate once
        }
      });
    }, { threshold: 0.5 });

    statItems.forEach(item => {
      observer.observe(item);
    });
  };

  const animateNumber = (element, target, duration) => {
    let start = 0;
    const increment = target / (duration / 16); // roughly 60fps
    
    const updateNumber = () => {
      start += increment;
      if (start < target) {
        element.innerText = Math.ceil(start);
        requestAnimationFrame(updateNumber);
      } else {
        element.innerText = target;
      }
    };
    
    updateNumber();
  };

  initCounters();

  // Re-init on Shopify theme editor section load
  document.addEventListener('shopify:section:load', initCounters);
});
